import React from 'react'
import "../Style/Product.css"
import ConnetedFooter from './Footer'
import ConnetedNav from './Navbar'

const Aboutus = () => {
    return (
        <div className='connetec__bankContainer'>
            <ConnetedNav />
        <div className='2xl:container xl:mx-auto'>
            <section className='md:py-20 py-5'>
                <div className='xl:px-[124px] px-5 md:px-10'>
                    <div className='flex justify-center'>
                        <span className='connected_banking_heading'>About Us</span>
                    </div>
                    <div className='lg:py-16 py-10'>
                        <span className='aboutus_content text-center block'>Haoda Pay is transforming business payments with seamless, secure, and smart solutions. Through our Connect Banking with Axis Bank, we integrate banking and payments into one powerful platform — enabling real-time transactions, faster reconciliation, and effortless cashflow management, so businesses can focus on growth while we handle the finance.</span>
                    </div>
                </div>

                <div className='lg:flex block px-5 xl:px-[124px] our_mission_section'>
                    <div className='lg:w-2/3 w-full'>
                        <div className='our_mission_heading pb-10'>Our mission</div>

                        <div className='grid gap-10'>
                            <div className='flex items-center gap-4'>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
                                        <g clip-path="url(#clip0_14169_1110)">
                                            <path d="M7.94531 14.957H52.5473V50.0976H7.94531V14.957Z" fill="#4E2AAD" />
                                            <path d="M27.0933 45.8456L26.8523 45.435C23.1585 39.1426 13.3453 25.7902 13.2467 25.656L13.1055 25.4643L16.448 22.1616L27.0314 29.5518C33.6955 20.9041 39.912 14.9652 43.9672 11.4965C48.4026 7.70262 51.2903 5.95661 51.3193 5.93959L51.3847 5.90039H57.0533L56.5134 6.38124C42.5807 18.7912 27.4796 45.1671 27.3288 45.4321L27.0933 45.8456Z" fill="#05FF7D" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_14169_1110">
                                                <rect width="56" height="56" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div className='our_mission_text'>To make business payouts faster, safer, and smarter.</div>
                            </div>
                             <div className='flex items-center gap-4'>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
                                        <g clip-path="url(#clip0_14169_1110)">
                                            <path d="M7.94531 14.957H52.5473V50.0976H7.94531V14.957Z" fill="#4E2AAD" />
                                            <path d="M27.0933 45.8456L26.8523 45.435C23.1585 39.1426 13.3453 25.7902 13.2467 25.656L13.1055 25.4643L16.448 22.1616L27.0314 29.5518C33.6955 20.9041 39.912 14.9652 43.9672 11.4965C48.4026 7.70262 51.2903 5.95661 51.3193 5.93959L51.3847 5.90039H57.0533L56.5134 6.38124C42.5807 18.7912 27.4796 45.1671 27.3288 45.4321L27.0933 45.8456Z" fill="#05FF7D" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_14169_1110">
                                                <rect width="56" height="56" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div className='our_mission_text'>To empower SMEs with tools that automate finance and cashflow.</div>
                            </div>
                             <div className='flex items-center gap-4'>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
                                        <g clip-path="url(#clip0_14169_1110)">
                                            <path d="M7.94531 14.957H52.5473V50.0976H7.94531V14.957Z" fill="#4E2AAD" />
                                            <path d="M27.0933 45.8456L26.8523 45.435C23.1585 39.1426 13.3453 25.7902 13.2467 25.656L13.1055 25.4643L16.448 22.1616L27.0314 29.5518C33.6955 20.9041 39.912 14.9652 43.9672 11.4965C48.4026 7.70262 51.2903 5.95661 51.3193 5.93959L51.3847 5.90039H57.0533L56.5134 6.38124C42.5807 18.7912 27.4796 45.1671 27.3288 45.4321L27.0933 45.8456Z" fill="#05FF7D" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_14169_1110">
                                                <rect width="56" height="56" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div className='our_mission_text'>To bridge the gap between banking and technology through innovation.</div>
                            </div>
                        </div>
                    </div>
                    <div className='lg:w-1/3 w-full'>
                        <div className='flex lg:block justify-center py-3'>
                            <img src="/images/our_mission_img.png" alt="our mission image" className='our_mission_image' />
                        </div>
                    </div>
                </div>

                <div className='flex justify-center pt-5 lg:pt-16'>
                    <div className='about_us_content'>
                        At Haoda Pay, we don’t just build payment solutions — we build trust, efficiency, and opportunities for businesses of every size.
                    </div>
                </div>
            </section>

            <section className='xl:px-[124px] px-5 py-5 lg:py-20'>
                 <span className='every_industry_heading block'>Built for Every Industry</span>
                 <span className='lg:py-16 py-5 every_industry_content block'>One platform. Every industry. Endless possibilities.</span>

                 <div className='flex justify-center flex-wrap items-center gap-6'>
                    <div className='every_industry_box'>
                       <div><img src="/images/shopping.png" alt='ahopping image' className='every_industry_image' /></div>
                       <div className='every_insdustry_box_text'>Startups</div>
                    </div>

                    <div className='every_industry_box'>
                       <div><img src="/images/shopping.png" alt='ahopping image' className='every_industry_image' /></div>
                       <div className='every_insdustry_box_text'>   Retail</div>
                    </div>

                    <div className='every_industry_box'>
                       <div><img src="/images/shopping.png" alt='ahopping image' className='every_industry_image' /></div>
                       <div className='every_insdustry_box_text'>   Manufacturing</div>
                    </div>

                    <div className='every_industry_box'>
                       <div><img src="/images/shopping.png" alt='ahopping image' className='every_industry_image' /></div>
                       <div className='every_insdustry_box_text'>Real Estate</div>
                    </div>

                    <div className='every_industry_box'>
                       <div><img src="/images/shopping.png" alt='ahopping image' className='every_industry_image' /></div>
                       <div className='every_insdustry_box_text'>Small Businesses</div>
                    </div>

                    <div className='every_industry_box'>
                       <div><img src="/images/shopping.png" alt='ahopping image' className='every_industry_image' /></div>
                       <div className='every_insdustry_box_text'>SMEs</div>
                    </div>

                    <div className='every_industry_box'>
                       <div><img src="/images/shopping.png" alt='ahopping image' className='every_industry_image' /></div>
                       <div className='every_insdustry_box_text'>Enterprises</div>
                    </div>

                    <div className='every_industry_box'>
                       <div><img src="/images/shopping.png" alt='ahopping image' className='every_industry_image' /></div>
                       <div className='every_insdustry_box_text'>Technology</div>
                    </div>

                    <div className='every_industry_box'>
                       <div><img src="/images/shopping.png" alt='ahopping image' className='every_industry_image' /></div>
                       <div className='every_insdustry_box_text'>Healthcare</div>
                    </div>

                    <div className='every_industry_box'>
                       <div><img src="/images/shopping.png" alt='ahopping image' className='every_industry_image' /></div>
                       <div className='every_insdustry_box_text'>Hospitality</div>
                    </div>

                    <div className='every_industry_box'>
                       <div><img src="/images/shopping.png" alt='ahopping image' className='every_industry_image' /></div>
                       <div className='every_insdustry_box_text'>Professionals</div>
                    </div>
                 </div>
            </section>
        </div>
        <ConnetedFooter />
        </div>
    )
}

export default Aboutus